<template>
<div>

    <b-col cols="6" offset="3" style="height:calc(100vh - 150px); overflow-y: auto;">
        
        <b-table-simple small bordered>
            <b-thead>
                <b-tr>
                    <b-th>Type</b-th>
                    <b-th>Match</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr>
                    <b-th>Alert Match Type</b-th>
                    <b-td>
                        {{alertMatchType}}
                    </b-td>
                </b-tr>
               
                <b-tr>
                    <b-th>Year of Birth</b-th>
                    <b-td>
                        {{yearOfBirthMatch}}
                    </b-td>
                </b-tr>
                <b-tr>
                    <b-th>Date of Birth Match</b-th>
                    <b-td>
                        {{dateOfBithMatch}}
                    </b-td>
                </b-tr>
                
                <b-tr>
                    <b-th>Country Match</b-th>
                    <b-td>
                        {{countryMatch}}
                    </b-td>
                </b-tr>
                
                <b-tr>
                    <b-th>Nature of Alert</b-th>
                    <b-td>
                        {{natureOfAlert}}
                    </b-td>
                </b-tr>
                <b-tr>
                    <b-th>City Match</b-th>
                    <b-td>
                        {{cityMatch}}
                    </b-td>
                </b-tr>
                
            </b-tbody>
        </b-table-simple>

       
    </b-col>
</div>
</template>

<script>
import {
    required
} from "vuelidate/lib/validators";

import {
    mapGetters,
    mapState
} from "vuex";
import {
    EventBus
} from "@/event-bus.js";
import moment from "moment";

export default {
    name: "WaldoAlertMatch",
    components: {

    },
    data() {
        return {
            collapse: false,
            date: null,
            alertMatchType:'Exact',
            yearOfBirthMatch:'No data',
            dateOfBithMatch:'Exact',
            natureOfAlert:'Partial',
            countryMatch:'Exact',
            cityMatch:'Exact'
        };
    },
    created() {},
    mounted() {

    },
    validations: {},
    computed: {
        ...mapGetters([]),
        ...mapState(["toggleAllCoppalse"])
    },
    watch: {
        toggleAllCoppalse(value) {
            this.collapse = value;
        }
    },
    methods: {

    },
    props: {
        alert: Object
    }
};
</script>
